import React, {ReactElement, useEffect, useRef, useState} from 'react';
import {FNPDPotentialStatement} from '@shared/services/service-mappers/FNPDServiceMappers';
import {apiFNPDPotentialStatements} from '@shared/services/FNPDService';
import {useDispatch, useSelector} from 'react-redux';
import {useSnackbar} from 'notistack';
import {SnackBarConfig} from 'src/utils/SnackBarConfig';
import GridTable, {
  DEFAULT_GRID_TABLE__OPTIONS
} from '@components/system/GridTable/GridTable';
import {
  CUSTOM_PAGINATION_SIZE_OPTIONS,
  FN_PD_AMOUNT_DEFAULT,
  FN_PD_STATEMENT_DEFAULT,
  PAGINATION_SIZE
} from 'src/constants/SystemConstants';
import {APP, DEFAULT_BLACK_COLOR} from 'src/style/variable';
import {Trans, useTranslation} from 'react-i18next';
import HelperUtils from '@shared/utils/HelperUtils';
import CurrencyFormatter from '@components/system/CurrencyFormatter/CurrencyFormatter';
import {Column} from 'material-table';
import {
  SEARCH_DEBOUNCE_DELAY,
  StatementNoticeType
} from '@shared/constants/Mapping';
import {
  Button,
  Divider,
  InputLabel,
  ListItemText,
  MenuItem,
  Radio,
  Select,
  Typography
} from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import {updateGuarantorDueNoticeType} from '@shared/services/DueInvoiceServices';
import HelperTexts from '../HelperTexts/HelpertTexts';
import './CheckStatementsStyle.scss';
import CustomSelectField from '@components/system/CustomSelectField/CustomSelectField';
import {getAllClinics} from '@shared/services/ClinicServices';
import {FilterClinicStyles} from '../DueInvoices/DueInvoices';
import {
  _setClinics,
  _statementsSelectedClinic
} from '@shared/store/actions/ClinicActions';
import NumberFormat from 'react-number-format';
import StyledOutlinedInput from '@components/system/FormInput/StyledOutlinedInput';
import {useDebouncedCallback} from 'use-debounce';
import {textFieldStyles} from '../TableDataAndStyles';
import ConfirmationDialog from '@components/system/ConfirmationDialog/ConfirmationDialog';
import ReloadIcon from '@components/system/ReloadIcon/ReloadIcon';

function getTranslationKey() {
  return 'FN_PD_STATEMEMT_CHECK';
}
const CheckStatements: React.FC<any> = props => {
  const {goBack} = props;
  const classes = textFieldStyles();
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const ClinicClasses = FilterClinicStyles();
  // hooks
  const dispatch = useDispatch();
  // states
  const [clinics, setClinics] = useState<any[]>([]);
  const [amount, setAmount] = useState<string>(FN_PD_AMOUNT_DEFAULT);
  const [statement, setStatement] = useState<string>(FN_PD_STATEMENT_DEFAULT);
  const [
    confirmDialogOpenForNoticeType,
    setConfirmDialogOpenForNoticeType
  ] = useState<boolean>(false);

  // redux states
  const groupId = useSelector((state: any) => state.auth.groupId);
  const selectedClinicId = useSelector(
    (state: any) => state.clinics.selectedClinicId || []
  );
  const selectedClinicLabel = useSelector(
    (state: any) => state.clinics.selectedClinicLabel || []
  );
  // ref
  const tableRef: any = useRef();

  const callGoBack = () => {
    if (typeof goBack === 'function') {
      goBack();
    }
  };
  const resetData = () => {
    if (
      tableRef.current?.onQueryChange &&
      typeof tableRef.current.onQueryChange === 'function'
    ) {
      tableRef.current.onQueryChange({page: 0});
    }
  };
  const updateAllStatements = async () => {
    if (!(selectedClinicId && selectedClinicId.length > 0 && groupId)) {
      return;
    }
    apiFNPDPotentialStatements(
      'UPDATE_ALL',
      groupId,
      selectedClinicId,
      amount,
      statement
    )
      .then(
        async (res: any): Promise<any> => {
          if (res.message) {
            enqueueSnackbar(res.message, SnackBarConfig('s'));
          }
        }
      )
      .catch(error => {
        enqueueSnackbar(error.message, SnackBarConfig('e'));
      })
      .finally(() => {
        resetData();
      });
  };
  const downloadFnPdStatements = async (id: any): Promise<void> => {
    if (!(selectedClinicId && selectedClinicId.length > 0 && groupId)) {
      return;
    }
    apiFNPDPotentialStatements(
      'DOWNLOAD',
      groupId,
      selectedClinicId,
      amount,
      statement
    )
      .then(
        async (res: any): Promise<any> => {
          const url = window.URL.createObjectURL(new Blob([res]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `fn_pd_statements.csv`);
          document.body.appendChild(link);
          link.click();
        }
      )
      .catch(error => {
        enqueueSnackbar(
          t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
          SnackBarConfig('e')
        );
      });
  };
  const getGroupClinics = async (id: any): Promise<void> => {
    try {
      const previousSelectedClinic: any[] = [...selectedClinicId];
      dispatch(_statementsSelectedClinic([], [], '', ''));
      getAllClinics(id)
        .then(
          async (res: any): Promise<any> => {
            if (res && res?.data && res?.data?.rows) {
              dispatch(_setClinics(res.data.rows));
              setClinics(res.data.rows);
              if (res.data.rows.length === 1) {
                const clinic: any = res.data.rows[0];
                dispatch(
                  _statementsSelectedClinic(
                    [clinic.id],
                    [clinic.name],
                    clinic?.zone,
                    clinic?.emr_provider
                  )
                );
              } else {
                const selectedClinicDetails: any = res.data.rows.find(
                  (clinic: any) => previousSelectedClinic.includes(clinic.id)
                );
                if (selectedClinicDetails) {
                  dispatch(
                    _statementsSelectedClinic(
                      [selectedClinicDetails.id],
                      [selectedClinicDetails.name],
                      selectedClinicDetails?.zone,
                      selectedClinicDetails?.emr_provider
                    )
                  );
                }
              }
            } else {
              setClinics([]);
              dispatch(_statementsSelectedClinic([], [], '', ''));
            }
          }
        )
        .catch(error => {
          enqueueSnackbar(
            t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
            SnackBarConfig('e')
          );
        });
    } catch (error: any) {
      enqueueSnackbar(
        (error && error.message) || t('CLINICS.CLINIC_GROUP_CLINICS_ERROR'),
        SnackBarConfig('e')
      );
    }
  };

  // debouncing amount
  const debounced = useDebouncedCallback(
    // function
    text => {
      if (!text || text.length >= 1) {
        resetData();
      }
    },
    // delay in ms
    SEARCH_DEBOUNCE_DELAY
  );
  const updateDueNoticeType = (
    guarantorId: number | string,
    statementType: string
  ) => {
    updateGuarantorDueNoticeType(groupId, selectedClinicId, guarantorId, {
      due_notice_type: statementType
    })
      .then((res: any) => {
        if (res.message) {
          enqueueSnackbar(res.message, SnackBarConfig('s'));
        }
        resetData();
      })
      .catch((err: any) => {
        enqueueSnackbar(err && err.message, SnackBarConfig('e'));
      });
  };
  // variables
  const columnList: Array<Column<FNPDPotentialStatement>> = [
    {
      title: t(`${getTranslationKey()}.GUARANTOR_NAME`),
      field: 'guarantor_name',
      render: rowData => {
        return (
          <span>
            {HelperUtils.commaSeparatedFullName(
              rowData.first_name,
              rowData.last_name,
              rowData.middle_name
            )}
          </span>
        );
      }
    },
    {
      title: t(`${getTranslationKey()}.ACCOUNT_NUMBER`),
      field: 'account_number',
      sorting: false,
      cellStyle: {
        whiteSpace: 'nowrap'
      },
      headerStyle: {
        textAlign: 'left'
      },
      render: rowData => (
        <div style={{display: 'flex'}}>
          <p>{rowData.emr_id ? rowData.emr_id : '—'}</p>
        </div>
      )
    },
    {
      title: t(`${getTranslationKey()}.GUARANTOR_PHONE`),
      field: 'phone',
      sorting: false,
      cellStyle: {
        whiteSpace: 'nowrap'
      },
      headerStyle: {
        textAlign: 'left'
      },
      render: rowData => (
        <div style={{display: 'flex'}}>
          <p>{rowData.phone ? rowData.phone : '—'}</p>
        </div>
      )
    },
    {
      title: t(`${getTranslationKey()}.GUARANTOR_NOTIFY_PHONE`),
      field: 'phone',
      sorting: false,
      cellStyle: {
        whiteSpace: 'nowrap'
      },
      headerStyle: {
        textAlign: 'left'
      },
      render: rowData => (
        <div style={{display: 'flex'}}>
          <p>{rowData.notification_phone ? rowData.notification_phone : '—'}</p>
        </div>
      )
    },
    {
      title: t(`${getTranslationKey()}.GUARANTOR_EMAIL`),
      field: 'email',
      sorting: false,
      render: rowData => (
        <div style={{textAlign: 'left'}}>
          <p>{rowData.email ? rowData.email : '—'}</p>
        </div>
      )
    },
    {
      title: t(`${getTranslationKey()}.DUE_AMOUNT`),
      field: 'original_due_amount',
      render: rowData => (
        <CurrencyFormatter
          value={rowData.original_due_amount}
          displayType={'text'}
          thousandSeparator={true}
          prefix={'$'}
          ignoreRound={true}
          useSign={true}
        />
      )
    },
    {
      title: t(`${getTranslationKey()}.STATEMENT_TYPE`),
      field: 'possible_statement_type',
      sorting: false,
      render: rowData => (
        <div>
          {(rowData.possible_statement_type === StatementNoticeType.FN.key ||
            rowData.possible_statement_type === StatementNoticeType.PD.key) && (
            <span
              className={[
                classes.tagsGuarantor,
                rowData.possible_statement_type === StatementNoticeType.FN.key
                  ? classes.tagsGuarantorFn
                  : '',
                rowData.possible_statement_type === StatementNoticeType.PD.key
                  ? classes.tagsGuarantorPd
                  : ''
              ].join(' ')}>
              {rowData.possible_statement_type === StatementNoticeType.FN.key
                ? StatementNoticeType.FN.label
                : StatementNoticeType.PD.label}
            </span>
          )}
        </div>
      ),
      align: 'left'
    },
    {
      title: t(`${getTranslationKey()}.ACTION`),
      field: '',
      sorting: false,
      render: rowData => (
        <Button
          variant={'outlined'}
          startIcon={<DoneIcon />}
          onClick={() => {
            updateDueNoticeType(rowData.id, rowData.possible_statement_type);
          }}>
          {t(`${getTranslationKey()}.UPDATE`)}
        </Button>
      ),
      align: 'left'
    }
  ];

  const clinicsMethod = (option: any) => {
    dispatch(
      _statementsSelectedClinic(
        [option.id],
        [option.name],
        option?.zone,
        option?.emr_provider
      )
    );
  };
  const clearClinicFilter = () => {
    dispatch(_statementsSelectedClinic([], [], '', ''));
  };
  const renderClinicFilters = (): ReactElement => {
    return (
      <div className={'select-filter'}>
        <InputLabel>{t(`${getTranslationKey()}.FILTERS.CLINIC`)}</InputLabel>
        <Select
          data-test-id="pcl-statements-selectPractice"
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          value={
            selectedClinicId.length
              ? selectedClinicLabel
              : [t('DUE_INVOICES.PLACEHOLDERS.SELECT_CLINIC')]
          }
          variant="outlined"
          fullWidth={true}
          style={selectedClinicId.length ? {} : {opacity: 0.5}}
          input={<CustomSelectField />}
          IconComponent={KeyboardArrowDownIcon}
          className="selectView select-clinic">
          <div className={ClinicClasses.root}>
            <div className={ClinicClasses.ClinicFilterHeader}>
              <Typography style={{fontSize: '1.3rem'}}>
                {t('PATIENTS.CLINICS')}
              </Typography>
              <Button
                className={ClinicClasses.clearAll}
                onClick={clearClinicFilter}>
                {t('COMMON.CLEAR_ALL')}
              </Button>
            </div>
            <Divider />
            <div className={ClinicClasses.ClinicMenu}>
              {clinics.map((clinic: any) => (
                <MenuItem
                  key={clinic.id}
                  value={clinic.name}
                  onClick={(): void => clinicsMethod(clinic)}>
                  <ListItemText
                    className={[
                      ClinicClasses.secondary,
                      ClinicClasses.primary
                    ].join(' ')}
                    primary={clinic.name}
                    secondary={`${clinic.city}, ${clinic.country}`}
                  />
                  <Radio checked={selectedClinicId.indexOf(clinic.id) > -1} />
                </MenuItem>
              ))}
            </div>
          </div>
        </Select>
        {/* </div> */}
      </div>
    );
  };

  const filterInputs = (): ReactElement => {
    return (
      <div className="input-filter" data-test-id="pcl-statements-amountLimit">
        <InputLabel>{t(`${getTranslationKey()}.FILTERS.AMOUNT`)}</InputLabel>
        <NumberFormat
          value={amount}
          onChange={event => {
            setAmount(
              event.target?.value?.replace(/\$/g, '').replace(/,/g, '')
            );
            debounced(event.target?.value);
          }}
          customInput={StyledOutlinedInput}
          thousandSeparator={true}
          prefix={'$'}
          placeholder={t(`${getTranslationKey()}.FN_PD_AMOUNT_LIMIT`)}
          margin={'dense'}
        />
      </div>
    );
  };

  const filterStatementCheckInputs = (): ReactElement => {
    return (
      <div
        className="input-filter"
        data-test-id="pcl-statements-statementsCheck">
        <InputLabel>{t(`${getTranslationKey()}.FILTERS.STATEMENT`)}</InputLabel>
        <NumberFormat
          value={statement}
          onChange={event => {
            setStatement(
              event.target?.value?.replace(/\$/g, '').replace(/,/g, '')
            );
            debounced(event.target?.value);
          }}
          customInput={StyledOutlinedInput}
          thousandSeparator={true}
          min={1}
          max={10}
          placeholder={t(`${getTranslationKey()}.FILTERS.STATEMENT`)}
          margin={'dense'}
        />
      </div>
    );
  };
  const refreshDataButton = (): ReactElement => {
    return (
      <div className="refresh-button">
        <ReloadIcon
          title={t('COMMON.FILTER_SCREEN.REFRESH').toString()}
          onClick={() => resetData()}
        />
      </div>
    );
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(resetData, [groupId, selectedClinicId]);
  useEffect(() => {
    getGroupClinics(groupId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  return (
    <div
      className={['check-statements-wrapper', classes.gridWrapper].join(' ')}>
      <HelperTexts
        title={t(`${getTranslationKey()}.TITLE`)}
        subTitle={t(`${getTranslationKey()}.SUBTITLE`)}
      />
      <div className="content">
        <div className="filters">
          <div className="filter-group-1">
            {renderClinicFilters()}
            {filterInputs()}
            {filterStatementCheckInputs()}
            {refreshDataButton()}
          </div>
          <div className="filter-group-2">
            <Button
              variant={'outlined'}
              color="primary"
              onClick={callGoBack}
              data-test-id="pcl-statements-goToStatements">
              {t(`${getTranslationKey()}.GO_BACK`)}
            </Button>
            <Button
              variant={'outlined'}
              startIcon={<DoneIcon color="primary" />}
              onClick={() => {
                setConfirmDialogOpenForNoticeType(true);
              }}
              disabled={
                !(selectedClinicId && selectedClinicId.length > 0 && groupId)
              }
              color="primary">
              {t(`${getTranslationKey()}.UPDATE_ALL`)}
            </Button>
            <Button
              onClick={downloadFnPdStatements}
              variant={'contained'}
              disabled={
                !(selectedClinicId && selectedClinicId.length > 0 && groupId)
              }
              color="primary">
              {t(`${getTranslationKey()}.DOWNLOAD`)}
            </Button>
          </div>
        </div>
        <GridTable
          tableRef={tableRef}
          columns={columnList}
          localization={{
            body: {
              emptyDataSourceMessage: selectedClinicId.length
                ? t(`${getTranslationKey()}.NO_RECORDS`)
                : t('DUE_INVOICES.SELECT_A_CLINIC')
            }
          }}
          options={{
            ...DEFAULT_GRID_TABLE__OPTIONS,
            search: false,
            showTitle: false,
            toolbar: false,
            paging: true,
            emptyRowsWhenPaging: false,
            sorting: true,
            pageSize: PAGINATION_SIZE.CHECK_FN_PD,
            pageSizeOptions: CUSTOM_PAGINATION_SIZE_OPTIONS.CHECK_FN_PD,
            showEmptyDataSourceMessage: true,
            maxBodyHeight: '100%',
            actionsColumnIndex: -1,
            tableLayout: 'auto',
            selection: false,
            draggable: false,
            headerStyle: {
              color: DEFAULT_BLACK_COLOR,
              fontFamily: APP.FONT_FAMILY.MEDIUM,
              flexDirection: 'row',
              position: 'sticky',
              top: 0
            }
          }}
          data={query => {
            return new Promise((resolve, reject) => {
              if (
                !groupId ||
                !selectedClinicId ||
                selectedClinicId.length === 0
              ) {
                resolve({
                  data: [],
                  page: query.page,
                  totalCount: 0
                });
                return;
              }
              apiFNPDPotentialStatements(
                'DATA',
                groupId,
                selectedClinicId,
                amount,
                statement,
                query.pageSize,
                query.page * query.pageSize
              )
                .then(res => {
                  if (res?.data?.rows) {
                    resolve({
                      data: res.data.rows,
                      page: query.page,
                      totalCount: res.data.count
                    });
                  } else {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 0
                    });
                  }
                })
                .catch((error: any) => {
                  reject();
                });
            });
          }}
          style={{
            margin: '1rem 0.1rem 5rem',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            boxShadow:
              '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px           rgb(0 0 0 / 12%)'
          }}
        />
      </div>
      <ConfirmationDialog
        open={confirmDialogOpenForNoticeType}
        onClose={response => {
          if (response === 'confirm') {
            // call update all API
            updateAllStatements();
          }
          setConfirmDialogOpenForNoticeType(false);
        }}
        title={
          <Trans
            i18nKey={`${getTranslationKey()}.UPDATE_ALL_DIALOG.TITLE`}
            components={[<strong key={'X'} />]}
          />
        }
        description={
          <Trans
            i18nKey={`${getTranslationKey()}.UPDATE_ALL_DIALOG.SUBTITLE`}
            values={{
              amount: amount,
              statement: statement
            }}
            components={[<strong key={'X'} />]}
          />
        }
      />
    </div>
  );
};

export default CheckStatements;
